import { render, staticRenderFns } from "./MarzipanoRectHotspot.vue?vue&type=template&id=17c6f244&scoped=true"
import script from "./MarzipanoRectHotspot.vue?vue&type=script&lang=js"
export * from "./MarzipanoRectHotspot.vue?vue&type=script&lang=js"
import style0 from "./MarzipanoRectHotspot.vue?vue&type=style&index=0&id=17c6f244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c6f244",
  null
  
)

export default component.exports